import { createSlice } from "@reduxjs/toolkit";
export const InitailFreightDetails = {
  FullPallet: 0,
  HalfPallet: 0,
  YourOrderVolume: 0,
  ShippingCharge: 0,
  ExpectedDeliveryDate: "",
  PackageType: 0,
  TotalPieces: 0,
};

export const initialState = {
  CurrID: 0,
  Address: "",
  CartID: 0,
  CartProductList: [],
  categories: [],
  SelectedAddress: null,
  ShippingError: null,
  SelectedPaymentMethod: 1,
  FreightDetails: InitailFreightDetails,
  SelectedDeliveryOption: null,
  SpecialInstruction: "",
  CartAmtDetails: null,
  TotalVolume: 0,
  BankCharge: 0,
  Discount: {
    DiscountPercent: "",
    DiscountAmount: "",
  },
  PackingSpecifications: []
};

const CartSlice = createSlice({
  name: "Cart",
  initialState,
  reducers: {
    setCartID: (state, action) => {
      state.CartID = action.payload;
    },
    setCurrID: (state, action) => {
      state.CurrID = action.payload;
    },
    setCartProductList: (state, action) => {
      state.CartProductList = action.payload;
    },
    setSelectedAddress: (state, action) => {
      state.SelectedAddress = action.payload;
    },
    setFreightDetails: (state, action) => {
      state.FreightDetails = action.payload;
    },
    setSpecialInstruction: (state, action) => {
      state.SpecialInstruction = action.payload;
    },
    setAddress: (state, action) => {
      state.Address = action.payload;
    },
    setCartAmtDetails: (state, action) => {
      state.CartAmtDetails = action.payload;
    },
    setDeliveryOption: (state, action) => {
      state.SelectedDeliveryOption = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.SelectedPaymentMethod = action.payload;
    },
    setTotalVolume: (state, action) => {
      state.TotalVolume = action.payload;
    },
    setEmptyCartData: () => initialState,
    setShippingError: (state, action) => {
      state.ShippingError = action.payload;
    },
    setDiscount: (state, action) => {
      state.Discount = action.payload;
    },
    setBankCharge: (state, action) => {
      state.BankCharge = action.payload;
    },
    setPackingSpecifications: (state, action) => {
      state.PackingSpecifications = action.payload;
    },

    setClearCartInfo: (state) => {
      // clear all infor 
      state.SelectedAddress = null;
      state.SelectedDeliveryOption = null;
      state.CartProductList = [];
      state.CartAmtDetails = null;
      state.FreightDetails = { ...InitailFreightDetails, PackageType: state.FreightDetails.PackageType };



    },
  },

});

export const {
  setCartID,
  setCurrID,
  setCartProductList,
  setSelectedAddress,
  setFreightDetails,
  setSpecialInstruction,
  setAddress,
  setCartAmtDetails,
  setDeliveryOption,
  setPaymentMethod,
  setTotalVolume,
  setEmptyCartData,
  setShippingError,
  setDiscount,
  setBankCharge,
  setPackingSpecifications,
  setClearCartInfo,
} = CartSlice.actions;

export default CartSlice.reducer;
